import { render, staticRenderFns } from "./MedicalDateFieldReadonly.vue?vue&type=template&id=3d23a743&scoped=true"
import script from "./MedicalDateFieldReadonly.vue?vue&type=script&lang=ts"
export * from "./MedicalDateFieldReadonly.vue?vue&type=script&lang=ts"
import style0 from "./MedicalDateFieldReadonly.vue?vue&type=style&index=0&id=3d23a743&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d23a743",
  null
  
)

export default component.exports